import { IDeprecatedUIState } from "../../../redux/modules/ui/reducer";
import AbstractTilesLayer from "../../AbstractTilesLayer";
import { getPrescanState, getAnyScanState } from "../../../redux/rootReducer";
import config from "../../../config";

export default class OrtophotoLayer extends AbstractTilesLayer {
  protected getTilesPath(state: any) {
    const scanState = getPrescanState(state);
    const anyScanState = getAnyScanState(state);

    if (!scanState.data && !anyScanState.data) {
      return null;
    }

    return (
      scanState.data?.orthophotoTilesPath ||
      anyScanState.data?.orthophotoTilesPath ||
      null
    );
  }

  protected shouldBeVisible(state: any) {
    const uiState: IDeprecatedUIState = state.deprecatedUi;
    return !uiState.elevationMapIsVisible;
  }

  protected getLayerOptions(state: any) {
    // Satellite maiden tiles exist up to zoom level 20 only
    const showsSatelliteMaiden =
      !getPrescanState(state).data?.orthophotoTilesPath &&
      Boolean(getAnyScanState(state).data?.isSatellite);

    return showsSatelliteMaiden
      ? config.satelliteOrthophotoLayerOptions
      : config.orthophotoLayerOptions;
  }
}
